import { createAction } from 'redux-actions';
import ParentalStatusSurvey from '../utils/ParentalStatusSurvey/ParentalStatusSurvey'

export const editParentalStatusSurvey = createAction('EDIT_PARENTAL_STATUS_SURVEY', ParentalStatusSurvey.edit);
export const setParentalStatusSurvey = createAction('SET_PARENTAL_STATUS_SURVEY')
export const updateParentalStatusSurvey = createAction('UPDATE_PARENTAL_STATUS_SURVEY',ParentalStatusSurvey.update)
// export const logoutAction = createAction('UPDATE_APPLICATION_FOR_ADMISSION', AuthDevise.logout);


// WEBPACK FOOTER //
// ./src/dashboards_redux/actions/ParentalStatusSurveyAction.jsx